import React from "react";
import { useParams } from "react-router-dom";
import LessonMockRoutes from "./LessonMockRoutes";

export default function LessonMockWrapper() {
  const { mockId } = useParams();
  return <LessonMockRoutes mockId={mockId} />;
}
// This wrapper component is used to pass the mockId parameter to the LessonMockRoutes component.